// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gt-0";
export var headerCellHover = "_gt-1";
export var readCellContainer = "_gt-2";
export var unreadIndicator = "_gt-3";